import React from 'react';
import { Routes, Route, BrowserRouter as Router, } from 'react-router-dom';
import DashboardPage from './pages/DashBoard/DashboardPage';
import TwoFactorAuth from './components/TwoFactorAuth';
import ProtectedRoute from './components/ProtectedRoute';
import ActivateAccount from './pages/UserManagement/ActivateAccount';
import useSessionRefresher from './hooks/useSessionRefresher';
import ActivateOrganisation from './pages/UserManagement/ActivateOrganisation';
import ResetPassword from './pages/UserManagement/ResetPasswordPage';





function App() {
  useSessionRefresher();
  return (
   

    
 <Router>
      <Routes>
        <Route path="/" element={<TwoFactorAuth />} />
        <Route path="/useractivation/:token" element={<ActivateAccount />} />
        <Route path="/organisationactivation/:token" element={<ActivateOrganisation />} />
        <Route path="/resetpassword/:token" element={<ResetPassword />} />
        
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>




  );
}

export default App; // ✅ Required for correct import in index.js
